<ng-container #dynamicContainer></ng-container>